// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__LGtxv","insightsList":"newBusinessInsightsMenu_insightsList__2sBcF","active":"newBusinessInsightsMenu_active__BuSbw"};